import React, { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';

import { ComboBox } from 'components/FormHelper/ComboBox/ComboBox';

export const AddressSearchComboBox = ({
  loading,
  onInputChange,
  onOpen,
  onClose,
  openOnInput,
  showLoadingWhileTyping,
  disabled,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isWaitingForSearch, setIsWaitingForSearch] = useState(false);
  const prevLoadingRef = useRef(false);

  useEffect(() => {
    if (loading || (prevLoadingRef.current && !loading)) {
      setIsWaitingForSearch(false);
    }
    prevLoadingRef.current = loading;
  }, [loading]);

  useEffect(() => {
    if (!disabled) return;
    setIsOpen(false);
    setIsWaitingForSearch(false);
  }, [disabled]);

  const handleOpen = (event) => {
    setIsOpen(true);
    if (onOpen) onOpen(event);
  };

  const handleClose = (event, reason) => {
    setIsOpen(false);
    if (onClose) onClose(event, reason);
  };

  const handleInputChange = (event, value, reason) => {
    const hasTypedInput = Boolean(String(value ?? '').trim());
    let didTriggerSearch = false;

    if (openOnInput && reason === 'input') {
      setIsOpen(hasTypedInput);
    }
    if (!hasTypedInput) {
      setIsOpen(false);
    }

    if (onInputChange) {
      didTriggerSearch = Boolean(onInputChange(event, value, reason));
    }

    if (showLoadingWhileTyping) {
      if (reason === 'input' && hasTypedInput && didTriggerSearch) {
        setIsWaitingForSearch(true);
      } else if (reason !== 'input' || !hasTypedInput) {
        setIsWaitingForSearch(false);
      } else if (!didTriggerSearch) {
        setIsWaitingForSearch(false);
      }
    }
  };

  return (
    <ComboBox
      {...rest}
      disabled={disabled}
      open={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      loading={loading || isWaitingForSearch}
      onInputChange={handleInputChange}
    />
  );
};

AddressSearchComboBox.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onInputChange: PropTypes.func,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  openOnInput: PropTypes.bool,
  showLoadingWhileTyping: PropTypes.bool,
};

AddressSearchComboBox.defaultProps = {
  disabled: false,
  loading: false,
  onInputChange: undefined,
  onOpen: undefined,
  onClose: undefined,
  openOnInput: true,
  showLoadingWhileTyping: true,
};
